import { extendedTokenApi } from 'api/tokenEndPoints';
import { User } from 'shared/model/user.model';

export const extendedApi = extendedTokenApi
  .enhanceEndpoints({
    addTagTypes: ['user'],
  })
  .injectEndpoints({
    overrideExisting: true,
    endpoints: builder => ({
      getCurrentUser: builder.query<User, void>({
        query: () => ({
          url: `/users/current`,
          method: 'GET',
        }),
        providesTags: ['user'],
      }),
      acceptCookies: builder.mutation<User, void>({
        query: () => ({
          url: `/users/current/acceptCookies`,
          method: 'PATCH',
        }),
        invalidatesTags: ['user', 'tokenUser'],
      }),
      rejectCookes: builder.mutation<User, void>({
        query: () => ({
          url: `/users/current/rejectCookies`,
          method: 'PATCH',
        }),
        invalidatesTags: ['user', 'tokenUser'],
      }),
    }),
  });

export const { useGetCurrentUserQuery, useAcceptCookiesMutation, useRejectCookesMutation } =
  extendedApi;
